import { PaytrieAPI } from '@paytrie/client'

import { FeatureFlagKey } from './constants'

export const fetchFeatureFlags = async (
  keys: readonly FeatureFlagKey[]
): Promise<Record<string, boolean>> => {
  const response = await PaytrieAPI.getFeatureFlags({ flags: keys.join(',') })

  if (response.status !== 200 || !response.data.success) {
    throw new Error(`Feature flag fetch failed (status ${response.status})`)
  }

  return Object.fromEntries(
    response.data.data.map((flag) => [flag.key, flag.enabled])
  )
}
